
import { Options, Vue } from "vue-class-component";
import Header from "@/components/Header.vue";
import ApiService from "../services/ApiService";
import StorageService from "@/services/StorageService";
import { wrapper } from "@/utils/wrapper";
import { useStore } from "vuex";
import { closePage, openPage } from "@/utils/patientLoggerPage";
import { getModulesCount } from "@/utils/modules";

@Options({
  components: {
    Header
  }
})
export default class Home extends Vue {
  viewName = "Home";
  private apiService = new ApiService();
  private storageService = new StorageService();
  globalStore = useStore();
  user: any = null;
  username: any = null;
  numberOfModules: any = null;
  treatmentSet = true;
  patientLoggerPageId: number | undefined;

  async created() {
    this.user = this.storageService.getUser();
    this.username = this.user.username;
    await this.getNumberOfModules();
  }

  async mounted() {
    this.patientLoggerPageId = await openPage(
      this.viewName,
      this.user.patientsId
    );
  }

  async beforeUnmount() {
    if (this.patientLoggerPageId && this.storageService.getUser()) {
      await closePage(this.patientLoggerPageId, this.user.patientsId);
    }
  }

  async getNumberOfModules() {
    const treatment = await wrapper(this.getTreatment());
    if (treatment.error) {
      this.treatmentSet = false;
      this.globalStore.commit("open", {
        type: "danger",
        title: this.$t("ALERTS.MODULES.GET.FAILED.TITLE"),
        text: this.$t("ALERTS.MODULES.GET.FAILED.TEXT")
      });
      return;
    }

    const modulesCount = await wrapper(getModulesCount(treatment.data));

    if (modulesCount.error) {
      this.treatmentSet = false;
      this.globalStore.commit("open", {
        type: "danger",
        title: this.$t("ALERTS.MODULES.GET.FAILED.TITLE"),
        text: this.$t("ALERTS.MODULES.GET.FAILED.TEXT")
      });
      return;
    }

    if (typeof modulesCount.data === "number") {
      this.treatmentSet = true;
      this.numberOfModules = modulesCount.data;
    } else {
      this.treatmentSet = false;
    }
  }

  async getTreatment() {
    const dataResponse = await wrapper(
      this.apiService.getTreatment(this.user.patientsId)
    );
    if (dataResponse.error) {
      console.error("get modules error ", dataResponse.error);
      throw dataResponse.error;
    }
    
    if (dataResponse.data) {
      return dataResponse.data;
    }
  }
}
